import React from 'react'
import FertilityCrypoBanner from "../components/img/FertilityCrypoBanner.jpg";
const CryopreservationBanner = () => {
  return (
    <div>
    <div id="carouselExampleCaptions" className="carousel slide" data-bs-ride="carousel">
      <div className="carousel-inner">
        <div className="carousel-item active">
          <img src={FertilityCrypoBanner} className="d-block w-100 carousel-image" alt="..." />
        </div>
      </div>
    </div>
  </div>
  )
}

export default CryopreservationBanner
